module.exports = __webpack_public_path__ + "images/backgrounds/wave.df4c04af6e6286830639.png";